/**
 * Правило СК щодо обов'язковості ІПН за віком у туризмі.
 *
 * Бекенд віддає в офері company.innRequiredFromAge (Guardian — 16):
 * страхувальник і кожен турист, якому вже виповнилось стільки років,
 * мусять вказати ІПН, а галочка «Відсутній ІПН» для них ховається.
 * null/відсутнє значення — обмежень немає.
 */
export function isIdentificationCodeRequiredByAge(dateBirth, requiredFromAge) {
  if (requiredFromAge === null || requiredFromAge === undefined || requiredFromAge === '') {
    return false;
  }

  if (!dateBirth || typeof dateBirth !== 'string' || dateBirth.length !== 10) {
    return false;
  }

  const birthDate = moment(dateBirth, 'DD.MM.YYYY', true);

  if (!birthDate.isValid()) {
    return false;
  }

  return moment().diff(birthDate, 'years') >= Number(requiredFromAge);
}

export default {
  computed: {
    tourismInnRequiredFromAge() {
      const offer = this.$store.getters.GET_TOURISM_INFO_OFFER;
      const value = offer?.company?.innRequiredFromAge;

      return value === null || value === undefined || value === '' ? null : Number(value);
    },
  },
  methods: {
    isInnRequiredByAge(dateBirth) {
      return isIdentificationCodeRequiredByAge(dateBirth, this.tourismInnRequiredFromAge);
    },
  },
}
